<template>
  <div class="deliverable-status-overview">
      <ul class="status-bar">
          <li 
          :title="taskTitle(task)"
          v-b-tooltip.hover.html
          v-for="task in deliverable.tasks" 
          :key="'deliverable-status-overview-'+task.id" 
          :style="{backgroundColor: taskColor(task)}">
          </li>
      </ul>
  </div>
</template>

<script>
export default {
    props: ['deliverable'],
    computed: {
        _() {
            return _
        }
    },
    methods: {
        parseJson(data) {
            try {
                return JSON.parse(data);
            } catch (e) {
                return data;
            }
        },
        taskColor(task) {
            let status = _.filter(task.taskFields, {field_key: 'status'});
            if(status.length) {
                return this.parseJson((status)[0].value).color;
            }
            return '';
        },
        taskTitle(task) {
            let status = _.filter(task.taskFields, {field_key: 'status'});
            if(status.length) {
                return this.parseJson((status)[0].value).name;
            }
            return '';
        }
    }
}
</script>

<style>

</style>